/* jshint esversion: 6 */

import Barba from 'barba.js/src';
const $ = require('jquery');
import {TweenMax, TimelineMax, Power4, Power2, Expo} from "gsap";
import CustomEase from '../vendors/CustomEase';
import {homeToDetailAnimation, homeToDetailAnimationNext} from './scrolling/DJAX_animations/homeToDetail';
import {detailToHome, detailToHomeNext} from './scrolling/DJAX_animations/detailToHome';
import {detailToDetail} from './scrolling/DJAX_animations/detailToDetail';
import PubSub from 'pubsub-js';
import classes from 'dom-classes';

require('./barbaViews');

export default class DJAX {
    constructor(reinitCB) {
        if(CCM_EDIT_MODE) return;
        
        const that = this;
        this.projectPage = null;
        this.setEvents(reinitCB);
        this.clicked = true;
        this.reinitCB = reinitCB;
        Barba.Pjax.start();

        let ifSafari = false;
        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1) {
            ifSafari = !(ua.indexOf('chrome') > -1)
        }
        if(!ifSafari){
            Barba.Prefetch.init();
        }

        Barba.Pjax.getTransition = function() {
            return that.chooseTransition();
        };

        PubSub.subscribe('Initiate Callback', function(message, url) {
            reinitCB(url);
        });
    }

    setEvents(cb) {       
        const that = this; 
        Barba.Dispatcher.on('initStateChange', function() {
            if (typeof ga === 'function') {
                ga('set', 'page', location.pathname);
                ga('send', 'pageview');
            }
        });

        Barba.Dispatcher.on('transitionCompleted', () => {
            if(!Barba.HistoryManager.prevStatus()) return;
            if(Barba.HistoryManager.currentStatus().namespace == 'home' && Barba.HistoryManager.prevStatus().namespace == 'project-page') return;
            cb.call();
            
            const previousSmoothScroll = window.smoothScrollInstances.shift();
            if(previousSmoothScroll) { 
                previousSmoothScroll.off();
                previousSmoothScroll.destroy();
            }
        });
        Barba.Dispatcher.on('linkClicked', function(a) {
            if(that.clicked) {
                return;
            }
            // console.log('linkClicked', a);
            window.stop();
            that.projectPage = $(a).is('.project-page') ? $(a) : null; 
            that.clicked = false;
        });
        Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container) {
           
            $(container).find('script').each(function (i, script) {
                var $script = $(script);
                $.ajax({
                    url: $script.attr('src'),
                    cache: true,
                    dataType: 'script',
                    success: function () {
                        $script.trigger('load');
                    }
                });
            });
        });
    }

    chooseTransition() {
        const that = this;
        return Barba.BaseTransition.extend({
            start: function() {
                Promise
                .all([this.newContainerLoading, that.fadeOut(this)])
                .then(that.fadeIn.bind(this));
            }
        });
    }

    fadeOut(context) {
        return new Promise((resolve, reject) => {
            context.newContainerLoading.then(() => {
                if(Barba.HistoryManager.prevStatus().namespace == 'home') PubSub.publish('RemoveScrollEvents');
                
                if( (Barba.HistoryManager.currentStatus().namespace == 'project-page' || Barba.HistoryManager.currentStatus().namespace == 'lets-chat') && Barba.HistoryManager.prevStatus().namespace == 'home') {                    
                    homeToDetailAnimation.call(this, context, resolve, reject);
                }
                else if(Barba.HistoryManager.currentStatus().namespace == 'home' && Barba.HistoryManager.prevStatus().namespace == 'project-page') {
                    detailToHome.call(this, context, resolve, reject);
                    const tabs = document.getElementById('siteHeader').getElementsByClassName('tabs')[0];
                    tabs.parentNode.removeChild(tabs);
                }
                else if(Barba.HistoryManager.currentStatus().namespace == 'project-page' && Barba.HistoryManager.prevStatus().namespace == 'project-page') {
                    detailToDetail.call(this, context, resolve, reject);
                }
                else {
                    TweenMax.to(context.oldContainer.children[0], 0.5, {autoAlpha: 0, scale: 1.02, onComplete: () => {
                        resolve();
                    }});
                }

            });
        });
    }

    fadeIn() {
        var _this = this;
        //close menu if open
        PubSub.publish('close-menu');
        var $headerVideo = $(this.newContainer).find('#headerVideo');

        var callBack = () => {
            //If there is a video and
            //If paused, meaning not loaded yet                   
            //Check for load
            if($headerVideo.length && $headerVideo[0].paused) { 
                $headerVideo.on('loadeddata', (e) => {    
                    //do the animation
                    homeToDetailAnimationNext.call(_this);
                    // this.reinitCB();
                });
            } else {
                //if the video is already playing, usually because it is already in cache or
                //there is no video, so no need to check for anything
                //do the animation
                homeToDetailAnimationNext.call(_this);
            }
        }
        // data-inverse-header

        if(Barba.HistoryManager.currentStatus().namespace == 'project-page' && Barba.HistoryManager.prevStatus().namespace == 'home') {
            callBack();
        }
        else if(Barba.HistoryManager.currentStatus().namespace == 'lets-chat' && Barba.HistoryManager.prevStatus().namespace == 'home') {
            location.reload();
        }
        else if(Barba.HistoryManager.currentStatus().namespace == 'home' && Barba.HistoryManager.prevStatus().namespace == 'project-page') {
            detailToHomeNext.call(_this);
        }
        else if(Barba.HistoryManager.currentStatus().namespace == 'project-page' && Barba.HistoryManager.prevStatus().namespace == 'project-page') {
            const oldContainer = this.oldContainer,
                newContainer = this.newContainer,
                nextSection = oldContainer.getElementsByClassName('next-project')[0];
            
            if(newContainer.getAttribute('data-id') === oldContainer.getAttribute('data-next-id')) {                
                callBack();
            }
            else {
                TweenMax.set(newContainer, {autoAlpha: 1});
                classes.remove(newContainer.getElementsByClassName('page--masks')[0], 'no-js');
                TweenMax.to(newContainer.getElementsByClassName('page--logo')[0], 0.3, {autoAlpha: 1});
                
                TweenMax.from(newContainer, 0.8, {x: - window.innerWidth, skewX: -10, ease: Power4.easeIn,
                    onComplete: () => {                        
                        callBack();
                    }
                });
                
            }   
        }

        else {
            
            TweenMax.from(this.newContainer.children[0], 1, {autoAlpha: 0, onComplete: () => {
                _this.done();
            }});
        }
    }

}


// WEBPACK FOOTER //
// ./app/components/djax.js